import BaseService from "./geral/BaseService";

const base = "OSWebController";

export default class OswebService extends BaseService {
    constructor() {
        super(base);
    };

    listarSolicitantes = () => {
        return super.httpGet(`/${base}/ListarSolicitantes`);
    };


    listarTipos = () => {
        return super.httpGet(`/${base}/ListarTipos`);
    };

    listarServicos = (tipo) => {
        return super.httpGet(`/${base}/ListarServicos/${tipo}`);
    };

    listarContainersOuDocumentos = (tipo, ehCodContainer, doc) => {
        return super.httpGet(`/${base}/ListarContainersOuDocumentos/${tipo}/${ehCodContainer}/${doc}`);
    };

    listarMotivos = (cdAgrupador) => {
        return super.httpGet(`/${base}/ListarMotivos/${cdAgrupador}`);
    };

    listarSituacoes = () => {
        return super.httpGet(`/${base}/ListarSituacoes`);
    };

    listar = (osId, status, cntr, situaOS, docCodCntrOuNf) => {
        let filtros = "?";
        if (osId) filtros = filtros.concat(`osId=${osId}`);
        if (status) filtros = filtros.concat(`&status=${status}`);
        if (situaOS) filtros = filtros.concat(`&situaOS=${situaOS}`);
        if (docCodCntrOuNf) filtros = filtros.concat(`&docCodCntrOuNf=${docCodCntrOuNf}`);
        filtros = filtros.replace("?&", "?");
        if (filtros.length === 1) filtros = "";
        return super.httpGet(`/${base}/ListarOSWeb${filtros}`);
    };

    salvar = (osweb) => {
        return super.httpPost(`/${base}/salvar`, osweb);
    };
}


// WEBPACK FOOTER //
// ./src/services/OswebService.js